import { toast } from 'react-toastify';
import i18n from '../../locales/i18n';

export const showSuccessToast = (alert: any, danger?: any) => {
	const dir = i18n.dir();

	toast(alert.message, {
		hideProgressBar: true,
		closeButton: false,
		autoClose: 5000,
		className: danger
			? 'backfround-light-danger'
			: 'backfround-light-green',
		position: dir === 'ltr' ? 'top-right' : 'top-left'
	});
};
